<h2 mat-dialog-title>Términos y Condiciones</h2>
<mat-dialog-content class="mat-typography">
    <p>
        1.- El usuario se compromete a ingresar a la sesión dentro de los primeros 15 minutos de la
        hora inicial de su cita (videollamada).
    </p>
    <br>
    <p>
        2.- El usuario deberá registrar sus datos de forma correcta, con la finalidad de hacerle
        llegar el hipervínculo de la sesión al correo registrado.
    </p>
    <br>
    <p>
        2.1.- En caso de no visualizar el correo con la información de la videollamada; se sugiere
        revisar la carpeta de "spam o no deseados", del correo que registro, si el correo de
        confirmación no aparece, en la carpeta de " recibidos, spam o no deseados"el usuario deberá
        enviar correo a videollamadas@conocer.gob.mx y solicitar el hipervínculo de la misma.
    </p>
    <br>
    <p>
        3.- Si el usuario no puede asistir a la videollamada en la fecha y hora seleccionada, deberá
        cancelar la sesión con por lo menos 24 horas de anticipación, para dar oportunidad a otros
        usuarios de agendar
    </p>
    <br>
    <p>
        4. Si perdiste tu cita a la videollamada por cualquier razón ajena al CONOCER, podrás
        agendar nuevamente una cita.
    </p>

    <p>
        Recuerda que tu asistencia a la videollamada es muy importante para nosotros, queremos
        verte, escucharte y resolver todas tus dudas sobre el proceso de certificación.
    </p>
    <p>
        Estamos a su servicio.
    </p>
</mat-dialog-content>
<div style="width: 100%; text-align: center">
    <mat-card-actions>
        <button mat-raised-button (click)="onNoClick()" color="primary" style="position: relative;
      right: 10px;">Aceptar</button>
        <button mat-raised-button (click)="cancelar()" color="primary">Cancelar</button>
    </mat-card-actions>
</div>